/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import i18n from "i18next";
import AuthService from "../services/authService";

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [user, setUser] = useState(null);
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "pt"
  );

  const loadFullUser = async (jwt) => {
    try {
      const decoded = jwtDecode(jwt);
      const fullUser = await AuthService.getUserById(decoded.sub);
      setUser(fullUser);

      if (fullUser.languageId) {
        setLanguage(fullUser.languageId.toLowerCase());
      }
    } catch (error) {
      console.error("Erro ao carregar utilizador:", error);
      logout();
    }
  };

  const login = async (email, password) => {
    const data = await AuthService.login(email, password);

    localStorage.setItem("token", data.accessToken);
    setToken(data.accessToken);

    await loadFullUser(data.accessToken);
  };

  const logout = () => {
    localStorage.removeItem("token");
    setToken(null);
    setUser(null);
  };

  const isAuthenticated = !!token;

  useEffect(() => {
    if (token) {
      loadFullUser(token);
    }
  }, [token]);

  useEffect(() => {
    const handleUnauthorized = () => {
      setToken(null);
      setUser(null);
    };

    window.addEventListener("auth:unauthorized", handleUnauthorized);

    return () => {
      window.removeEventListener("auth:unauthorized", handleUnauthorized);
    };
  }, []);

  useEffect(() => {
    i18n.changeLanguage(language);
    localStorage.setItem("language", language);
  }, [language]);

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        isAuthenticated,
        login,
        logout,
        language,
        setLanguage,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
